export default __webpack_public_path__ + "static/media/IMGPLACE.5f67f681.png";